import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

import { SelectedTab } from './types'

interface UseNavbarConfigProps {
  orgId: string
}

const selectedTabValues = Object.values(SelectedTab)

const selectedTabLookup = new Map(
  selectedTabValues.map((tab) => [tab.toLowerCase(), tab])
)

const findSelectedTab = (item: string): SelectedTab | undefined => {
  return selectedTabLookup.get(item.toLowerCase())
}

export const useNavbarConfig = ({ orgId }: UseNavbarConfigProps) => {
  const { entries: navbarConfigEntries, isLoading: isNavbarConfigLoading } =
    useRolodexEntries({
      type: [RolodexEntryType.NAVBAR_CONFIG],
      tags: {
        organization: [orgId],
      },
    })

  const allowedNavbarItems = useMemo((): SelectedTab[] | undefined => {
    if (isNavbarConfigLoading) {
      return []
    }

    const allowedItems = navbarConfigEntries[0]?.data.allowed_navbar_items as
      | string[]
      | undefined

    if (!allowedItems || allowedItems.length === 0) {
      return undefined
    }

    const filteredItems = allowedItems
      .map(findSelectedTab)
      .filter((item): item is SelectedTab => item !== undefined)

    return filteredItems.length > 0 ? filteredItems : undefined
  }, [isNavbarConfigLoading, navbarConfigEntries])

  return allowedNavbarItems
}
